"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _sort = require('shared/services/sort');
var _uuid = require('shared/services/uuid');
var _message = require('shared/enum/message');




/* Client-only fields on rows this reducer creates or updates locally. */






































const initialState = {}

const VERY_BIG_NUMBER = 1000000000000

const hasValidImageDimensions = (FileInfo) => Boolean(
  _optionalChain([FileInfo, 'optionalAccess', _ => _.ImageWidth]) && _optionalChain([FileInfo, 'optionalAccess', _2 => _2.ImageHeight]) &&
  Number.isFinite(FileInfo.ImageWidth) && Number.isFinite(FileInfo.ImageHeight) &&
  FileInfo.ImageWidth > 0 && FileInfo.ImageHeight > 0,
)

function carryLocalPreview (previousMessage, incomingMessage) {
  const previousFileInfo = _optionalChain([previousMessage, 'optionalAccess', _3 => _3.FileInfo])
  const incomingFileInfo = _optionalChain([incomingMessage, 'optionalAccess', _4 => _4.FileInfo])
  if (!previousFileInfo || !incomingFileInfo) return incomingMessage

  const preservePreview = incomingFileInfo.PreviewUrl == null && previousFileInfo.PreviewUrl
  const preserveDimensions =
    previousFileInfo.PreviewUrl &&
    incomingFileInfo.ImageWidth == null && incomingFileInfo.ImageHeight == null &&
    hasValidImageDimensions(previousFileInfo)
  if (!preservePreview && !preserveDimensions) return incomingMessage

  return {
    ...incomingMessage,
    FileInfo: {
      ...incomingFileInfo,
      ...(preservePreview ? { PreviewUrl: previousFileInfo.PreviewUrl } : {}),
      ...(preserveDimensions
        ? {
            ImageWidth: previousFileInfo.ImageWidth,
            ImageHeight: previousFileInfo.ImageHeight,
          }
        : {}),
    },
  }
}

/* The server echo replaces a local row; it keeps the send that row was part of. */
function carrySend (previousMessage, incomingMessage) {
  const LocalSentAt = _optionalChain([previousMessage, 'optionalAccess', _5 => _5.LocalSentAt])
  return LocalSentAt && !incomingMessage.LocalSentAt ? { ...incomingMessage, LocalSentAt } : incomingMessage
}

/* when messages come in they come in as a map of  messageKey -> message so we leverage that
 */
function combineMessages (
  currentMessagesArr = [],
  newMessagesMap = {},
) {
  const currentMessagesMap = currentMessagesArr.reduce((acc, m) => {
    acc[m.MessageKey] = m
    return acc
  }, {})

  Object.values(newMessagesMap).forEach(m => {
    const previous = currentMessagesMap[m.MessageKey]
    currentMessagesMap[m.MessageKey] = carrySend(previous, carryLocalPreview(previous, m))
  })

  // sortByString compares with > and <, which orders numeric Sequences
  // numerically; the casts only satisfy its string signature.
  return Object.values(currentMessagesMap).sort((a, b) => _sort.sortByString.call(void 0, b.Sequence , a.Sequence ))
}

/* A send keeps only its own conversation's messages and drops the others',
 * which reload from the server when reopened. Rows that haven't reached the
 * server exist nowhere else, so they stay: a part still uploading in another
 * chat, or one that failed and is waiting for Retry. Only local rows carry
 * deliveryStatus; the server's messages never do. */
const isUnsent = (m) =>
  m.deliveryStatus === _message.deliveryStatus.SENT || m.deliveryStatus === _message.deliveryStatus.FAILED

function onlyConversation (state, ConversationKey, messages) {
  const next = {}
  for (const key of Object.keys(state) ) {
    if (key === ConversationKey) continue
    const unsent = state[key].filter(isUnsent)
    if (unsent.length) next[key] = unsent
  }
  next[ConversationKey] = messages
  return next
}

 function messageReducer (
  state = initialState,
  action,
  globalState,
) {
  const currentUser = globalState.currentUser
  /* variables we redefine later on */
  let Conversations,
    ConversationKey,
    MessageKey,
    FileKey,
    message,
    messages,
    currentHighestSequence

  switch (action.type) {
    case _actionCreators2.default.updateNotificationAction.type:
    case _actionCreators2.default.loadConversationActions.SUCCESS.type:
    case _actionCreators2.default.loadConversationAroundTimeActions.SUCCESS.type:
    case _actionCreators2.default.loadConversationAroundMessageActions.SUCCESS.type:
      Conversations = (action.payload ).Conversations /* map of conversationKey -> conversation */

      // Writes into `state` itself (the reduce seed), as the JS did.
      return Object.values(Conversations || {}).reduce((state, c) => {
        const newMessagesMap = c.Messages
        const currentMessagesArr = state[c.ConversationKey] ? state[c.ConversationKey] : []

        state[c.ConversationKey] = combineMessages(currentMessagesArr, newMessagesMap)
        return state
      }, state)

    case _actionCreators2.default.sendMessageToConversationActions.REQUEST.type: {
      const { payload, meta } = action 
      const { ConversationKey, MessageKey, TextContent } = payload
      const { isRetrying, SentAt, ReplyToMessageKey, ReplyPreview, Mentions } = meta

      messages = state[ConversationKey] || []
      currentHighestSequence = messages[messages.length - 1]
        ? messages[messages.length - 1].Sequence
        : VERY_BIG_NUMBER

      // Typing compromise: the optimistic row has only the fields the UI
      // reads before the server echo replaces it (no ConversationKey,
      // FileReference, ...).
      const newMessage = {
        Sequence: currentHighestSequence + 1,
        SentAt: _nullishCoalesce(SentAt, () => ( new Date().toISOString())),
        MessageKey: MessageKey,
        SenderType: "user",
        MessageType: "text",
        UserKey: currentUser.UserKey,
        PatientKey: _uuid.EMPTY_BLUID,
        TeamKey: _uuid.EMPTY_BLUID,
        MessageText: TextContent,
        deliveryStatus: _message.deliveryStatus.SENT,
        // A retried part keeps its send's SentAt (sendSentAtOf), so it keeps
        // its send; a message sent, or retried, on its own has none.
        LocalSentAt: SentAt,
        // These are the "view" fields from the server
        DisplayName: currentUser.Name,
        Avatar: currentUser.ProfilePicture,
        ...(ReplyToMessageKey ? { ReplyToMessageKey } : {}),
        ...(ReplyPreview ? { ReplyPreview } : {}),
        ...(_optionalChain([Mentions, 'optionalAccess', _6 => _6.length]) ? { Mentions } : {}),
      } 

      const conversation = isRetrying
        ? messages.map(m => m.MessageKey === MessageKey
          ? { ...m, ...newMessage, Sequence: m.Sequence }
          : m,
        )
        : messages.concat(newMessage)

      // Returns only this conversation's key, as the JS did.
      return onlyConversation(state, ConversationKey, conversation)
    }

    case _actionCreators2.default.sendMessageToConversationActions.FAILURE.type: {
      const { ConversationKey, MessageKey } = (action ).meta
      const messages = state[ConversationKey] || []

      return onlyConversation(state, ConversationKey, messages.map(
        m => m.MessageKey === MessageKey
          ? {
              ...m,
              deliveryStatus: _message.deliveryStatus.FAILED,
              hasFailedPreviously: true, // Only used to ignore its invalid Sequence
            }
          : m,
      ))
    }

    case _actionCreators2.default.deleteMessageFromConversationActions.SUCCESS.type: {
      const { payload, meta } = action 
      const { ConversationKey } = meta
      const { MessageKey } = payload
      const messages = state[ConversationKey] || []

      return onlyConversation(state, ConversationKey, messages.map(m =>
        m.MessageKey !== MessageKey ? m : { ...m, Deleted: true },
      ))
    }

    case _actionCreators2.default.uploadFileActions.REQUEST.type: {
      const { meta } = action 
      const { ConversationKey } = action.payload 
      const file = action.payload.file 
      const { MessageKey, isRetrying, SentAt, ReplyToMessageKey, ReplyPreview } = meta
      const messages = state[ConversationKey] || []
      const currentHighestSequence = messages[messages.length - 1]
        ? messages[messages.length - 1].Sequence
        : VERY_BIG_NUMBER

      const FileInfo = {
        Size: file.size,
        PreviewUrl: file.preview,
        LocalMime: file.type,
        ImageWidth: file.width,
        ImageHeight: file.height,
      }

      // Typing compromise: an optimistic row, as above; FileInfo holds
      // only the local fields until the server echo.
      const newMessage = {
        Sequence: currentHighestSequence + 1,
        SentAt: _nullishCoalesce(SentAt, () => ( new Date().toISOString())),
        MessageKey: MessageKey,
        SenderType: "user",
        MessageType: "file",
        UserKey: currentUser.UserKey,
        PatientKey: _uuid.EMPTY_BLUID,
        TeamKey: _uuid.EMPTY_BLUID,
        FileName: file.name,
        FileInfo,
        FileReference: null,
        Uploading: true,
        deliveryStatus: _message.deliveryStatus.SENT,
        // As for text: a retried part keeps its send's, a lone file has none.
        LocalSentAt: SentAt,
        ...(ReplyToMessageKey ? { ReplyToMessageKey } : {}),
        ...(ReplyPreview ? { ReplyPreview } : {}),
      } 

      const conversation = isRetrying
        ? messages.map(m => m.MessageKey === MessageKey
          ? { ...newMessage, Sequence: m.Sequence }
          : m,
        )
        : messages.concat(newMessage)

      return onlyConversation(state, ConversationKey, conversation)
    }

    case _actionCreators2.default.sendFileToConversationActions.REQUEST.type: {
      const { payload, meta } = action 
      ConversationKey = payload.ConversationKey
      FileKey = payload.FileKey
      MessageKey = meta.MessageKey
      messages = state[ConversationKey] || []
      message = messages.find(m => m.MessageKey === MessageKey)
      if (!message) return state

      const copiedMessage = { ...message }

      copiedMessage.Uploading = false
      copiedMessage.FileReference = FileKey

      state[ConversationKey] = combineMessages(messages, { [MessageKey]: copiedMessage })
      return state
    }

    case _actionCreators2.default.sendFileToConversationActions.FAILURE.type: {
      const { ConversationKey, MessageKey, isAborted } = (action ).meta
      const messages = state[ConversationKey] || []

      const newMessages = messages.map(
        m => m.MessageKey === MessageKey
          ? {
              ...m,
              deliveryStatus: isAborted
                ? _message.deliveryStatus.CANCELED
                : _message.deliveryStatus.FAILED,
              // Its local Sequence may be given to a later message, as for a
              // failed text send.
              hasFailedPreviously: true,
            }
          : m,
      )

      return onlyConversation(state, ConversationKey, newMessages)
    }

    case _actionCreators2.default.pruneLocalMessageAction.type: {
      const { ConversationKey, MessageKey } = (action ).payload
      const messages = state[ConversationKey] || []

      return onlyConversation(state, ConversationKey, messages.filter(m => m.MessageKey !== MessageKey))
    }
  }

  return state
} exports.default = messageReducer;
